<template>
    <footer id="footer" class="footer" >
        <p class="footer__copy"> ©2009-{{new Date().getFullYear()}}. {{ trans("All rights reserved") }} </p>
        <nav class="footer__nav">
            <ul class="list footer-nav-list">
                <li class="list__element footer-nav-list__element">
                    <a href="/contacts" class="footer-nav-list__link"> {{ trans("Contacts") }} </a>
                </li>
                <li class="list__element footer-nav-list__element">
                    <a href="/public-offer" class="footer-nav-list__link"> {{ trans("Information") }} </a>
                </li>
                <li class="list__element footer-nav-list__element">
                    <a href="/privacy-policy" class="footer-nav-list__link"> {{ trans("Confidentiality") }} </a>
                </li>
                <li v-if="showSubscribeButton"
                    class="list__element footer-nav-list__element">
                    <a href="/subscribe"
                       :class="['footer-nav-list__link', {'disabled': isSubscribed}]"
                       id="air-container-subscribe-pop"
                       @click="isSubscribed && $event.preventDefault()">
                        {{ isSubscribed ? trans('You have already subscribed') : trans("Subscribe news") }}
                    </a>
                </li>
            </ul>
        </nav>

        <div class="footer__network_row">
            <Socials />

        </div>
        <p class="footer__phone_row">
            <a href="mailto:info@batnorton.com" class="footer__phone"> info@batnorton.com </a>
        </p>

        <div class="air-container  air-container-subscribe-pop " :class="showSubscribe ? 'air-container_active' :''">
            <div class="popup-air " :class="showSubscribe ? ' popup-air_active' :''">
                <div class="air-close" @click="showSubscribe = false"></div>
                <div class="subscription-modal">
                    <h3 class="subscription-modal__title"> {{trans(":key % discount on the next order",10)}} </h3>
                    <h3 class="subscription-modal__title">{{trans("News, Promotions, Special offers")}}</h3>
                    <picture class="subscription-modal__image">
                        <img src="https://batnorton.com/img/subscription_modal_image.jpg" alt="Подписаться">
                    </picture>
                    <form class="subscription-modal__form ">
                        <div class="input-wrapper ">
                            <span class="input-wrapper__title">E-mail</span>
                            <input v-model="email" type="text" name="email" class="input-element input-wrapper__element-inp input-wrapper__element-inp-js">
                        </div>
                        <button @click.prevent="subscribe" style="max-height: 42px;" class="btn btnV2 subscription-modal__button-js">
                            {{ trans("Subscribe") }}</button>
                    </form>
                </div>
            </div>
        </div>
        <EmailSubscription v-if="subscrPopupType==='email' && !isSubscribePage && !promoPopupActive" />
        <Secret v-if="subscrPopupType==='secret'"/>
        <VmestePopup v-if="promoPopupActive" />
    </footer>
</template>

<script>
import MobilMenu from '@/src/components/MobilMenu.vue';
import Socials from '@/src/components/Socials.vue';
import Secret from './Airs/secret.vue';
import EmailSubscription from './Airs/EmailSubscription.vue';
import VmestePopup from './Airs/VmestePopup.vue';
import store from '../store.js';

export default {
    name: "Footer",
    components: {Secret, Socials, MobilMenu, EmailSubscription, VmestePopup},
    data(){
        return{
            showSecretLink:false,
            showSubscribe:false,
            showSubscribeButton:true,
            showAir:false,
            email:'',
            subscrPopupType: ''
        }
    },
    mounted() {
        if (this.isSubscribePage) {
            store.commit('closeEmailSubscriptionAir')
            store.commit('resetTime')
        }

        if (this.$store.state.settings.site_id == 1) {
            if (this.$store.state.settings?.secret?.stage != 0) {
                this.subscrPopupType = 'secret';
            } else {
                this.subscrPopupType = 'email';
            }
        } else if (this.$store.state.settings.site_id == 2) {
            if (this.$store.state.settings?.secret?.stage != 0) {
                this.subscrPopupType = 'secret';
            } else {
                this.subscrPopupType = 'email';
            }
        }
    },
    methods:{
        validateEmail() {
            const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
            return emailRegex.test(this.email)
        },
        async subscribe() {
            if(this.email.length === 0){
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Fill in the email'),
                    type: 'error',
                });
            }else if(!this.validateEmail()){
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Incorrect email address'),
                    type: 'error',
                });
            }else {
                await axios.get('/api/v1/set-subscribe', {
                    params: this.setParam({
                        email: this.email,
                        guest:this.$store.state.settings.guest.id,
                        type: 1
                    })
                })
                    .then(data => {
                        if(data.data.status == 'success'){
                            this.$notify({
                                title: this.trans('Notification'),
                                text: data.data.text,
                                type: 'success',
                            });
                        }
                        if(data.data.status == 'error'){
                            this.$notify({
                                title: this.trans('Error'),
                                text: data.data.text,
                                type: 'error',
                            });

                        }
                        this.showSubscribe = false
                    })
            }
        },
    },
    computed: {
        promoPopupActive() {
            const popup = this.$store.state.settings?.promo_popup
            return Boolean(popup?.active && popup.storage_key && popup.image_desktop && popup.image_mobile)
        },
        isSubscribePage() {
            return /\/subscribe\/?$/.test(window.location.pathname)
        },
        isSubscribed()  {
            let data = false
            let subscrKey = 'email-subscription-air-1'
            if (
                (this.$store.state.settings.site_id == 1 && this.$store.state.settings?.secret?.stage != 0) ||
                (this.$store.state.settings.site_id == 2 && this.$store.state.settings?.secret?.stage != 0)
            ) {
                const subscrKey = this.$store.state.settings.secret.key + '-air';
            }

            data = JSON.parse(localStorage.getItem(subscrKey))

            if (!data) {
                return false
            }
            return Boolean(data.subscribed)
        },
    }
}
</script>

<style scoped>
 .disabled {
     color: #9b9fa1;
 }
</style>
